<div class="c-image-carousel">
	<button (click)="doClose()" class="c-image-carousel__close-btn">
		<tvcore-icon name="close"></tvcore-icon>
	</button>

	<div class="c-image-carousel__full">
		@if (full(); as fi) {
			@if (fi.youtubeUrl) {
				@if (getEmbedUrl(fi); as url) {
					<iframe [src]="url" allow="autoplay; picture-in-picture" allowfullscreen></iframe>
				} @else {
					<img [src]="fi.url" />
				}
			} @else {
				<img [src]="fi.url" />
			}
		}
	</div>

	<div class="c-image-carousel__previews">
		@for (image of images(); track image.id) {
			<div (click)="index.set($index)" [class.c-image-carousel__previews__img--active]="index() === $index" class="c-image-carousel__previews__img">
				<img [src]="image.url" />

				@if (image.youtubeUrl) {
					<tvcore-icon name="video"></tvcore-icon>
				}
			</div>
		}
	</div>
</div>
